import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fileupload" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  class: "empty-state",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "empty-state__input" }
const _hoisted_5 = { class: "empty-state__body" }
const _hoisted_6 = {
  key: 0,
  class: "body__cta fs-medium"
}
const _hoisted_7 = {
  key: 1,
  class: "body__cta fs-medium"
}
const _hoisted_8 = { class: "empty-state__footer mar-t--20" }
const _hoisted_9 = ["id", "multiple", "accept", "name"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 0,
  class: "table table--responsive"
}
const _hoisted_12 = { class: "table__wrapper" }
const _hoisted_13 = {
  "data-init": "auto",
  class: "table-vertical-align"
}
const _hoisted_14 = { class: "sc-gray-mid" }
const _hoisted_15 = { class: "nowhow-table-max-50 sc-gray-mid t-right td-action" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "sc-gray-mid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.css)
    }, [
      _createElementVNode("div", {
        id: 'drop-' + _ctx.id,
        class: "fileupload-field"
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "empty-state__bg" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "empty-state__icon mar-t--50" }, [
              _createElementVNode("i", {
                class: "icon icon-087-upload icon--s4 blue",
                "aria-hidden": "true"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.multiple)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('allg.dropzone.ziehen')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('allg.dropzone.ziehen')), 1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock("input", {
                id: _ctx.id,
                key: _ctx.id,
                type: "file",
                multiple: _ctx.multiple,
                accept: _ctx.acceptTypes,
                name: _ctx.id,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFiles && _ctx.addFiles(...args)))
              }, null, 40, _hoisted_9)),
              _renderSlot(_ctx.$slots, "button", {}, () => [
                _createElementVNode("label", {
                  class: "v-btn v-btn--depressed theme--light v-size--default primary",
                  for: _ctx.id
                }, _toDisplayString(_ctx.$t('allg.dropzone.durchsuchen')), 9, _hoisted_10)
              ], true)
            ])
          ])
        ])
      ], 8, _hoisted_2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.css)
    }, [
      (!_ctx.instantUpload && _ctx.showFilelist)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", _hoisted_13, [
                _createElementVNode("tbody", null, [
                  (_ctx.files.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.files, (file, key) => {
                        return (_openBlock(), _createElementBlock("tr", { key: key }, [
                          _createElementVNode("td", _hoisted_14, _toDisplayString(file.name), 1),
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("i", {
                              class: "icon-022-close",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.removeFile(key))
                            }, null, 8, _hoisted_16)
                          ])
                        ]))
                      }), 128))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                        _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t('allg.dropzone.notselected')), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("td", { class: "nowhow-table-max-50 sc-gray-mid t-right td-action" }, null, -1))
                      ]))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}